// extracted by mini-css-extract-plugin
export var button = "_6x-0";
export var icon = "_6x-1";